<script setup>
import { dropdownTriggers } from '@/constants/dropdown';

const { canHover } = useHoverSupport();

const {
  public: { mainSiteUrl },
} = useRuntimeConfig();
</script>

<template>
  <header class="header">
    <div class="container">
      <div class="header__inner">
        <a :href="`${mainSiteUrl}`" target="_blank" class="header__link">
          <CIcon name="new-tab" class="header__icon header__icon--link" />

          <span class="header__font header__font--link">
            {{ $t('header.visit') }} railmonsters.com
          </span>
        </a>

        <BundlesLangSelect
          :trigger-event="
            canHover ? dropdownTriggers.hover : dropdownTriggers.click
          "
        />
      </div>
    </div>
  </header>
</template>

<style scoped lang="scss">
.header {
  $parent: &;

  padding-block: em(11);
  padding-inline: 0;

  @include media-breakpoint-mobile {
    padding-block: em(8);
    padding-inline: 0;
  }

  &__inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__icon {
    &--link {
      @include box(em(17));
      color: rgba($color-black, 0.4);
      transition: color $time-2;

      @include media-breakpoint-mobile {
        @include box(em(14));
      }
    }
  }

  &__link {
    color: $color-main-1;
    display: flex;
    align-items: center;
    gap: em(13);
    transition: color $time-2;

    @include media-breakpoint-mobile {
      gap: em(8);
    }

    @include hover {
      color: $color-second-1;

      #{$parent} {
        &__icon {
          &--link {
            color: inherit;
          }
        }
      }
    }
  }

  &__font {
    &--link {
      font-size: em(17);

      @include media-breakpoint-mobile {
        font-size: em(14);
      }
    }
  }
}
</style>
